// blocco form

$( document ).on('keyup', ".form-block__labelWrapper input", function() {
    if( $(this).val().length === 0 ) {
        $(this).closest('.form-block__labelWrapper').removeClass('active');
    } else {
        $(this).closest('.form-block__labelWrapper').addClass('active');
    }
});

function loadRecaptchaBlockForm(form) {
    grecaptcha.execute(recaptchaKey, { action: 'recaptcha' }).then(function (token) {
        var recaptchaResponse = document.getElementById('page_block_recaptcha');
        recaptchaResponse.value = token;

        $.ajax({
            url: url__block_send+'?pageBlockId='+document.getElementById('block-form').getAttribute('data-block-id'),
            data: new FormData(document.getElementById('block-form')),// the formData function is available in almost all new browsers.
            type: "post",
            contentType: false,
            processData: false,
            cache: false,
            dataType: "json", // Change this according to your response from the server.
            error: function(err) {
                alert('Ops! SI è verificato un errore. Riprova più tardi.');
            },
            success: function(data) {
                $('form#block-form').replaceWith(data.html);
                setTimeout(function () {
                    initFormBlock();
                }, 500);
                if (data.result) {
                    MicroModal.show('contacts-form-modal');
                    window.dataLayer =  window.dataLayer || [];
                    dataLayer.push({
                        'event': 'submit',
                        'form_submitted': 'block_contacts'
                    });
                    // fbq_trackCustom('submit__block_contacts');
                }
            },
            complete: function(){
                // console.log("Request finished.");
            }
        });
    });
}

var submitHandlerBlock = function(e) {
    e.preventDefault();
    e.target.removeEventListener('submit', submitHandlerBlock, false);

    document.getElementById('block-form-submit').classList.add('d-none');
    document.getElementById('block-form-loader').classList.remove('d-none');

    var form = $(this);
    loadRecaptchaBlockForm(form);
};

function initFormBlock() {
    document.getElementById('block-form').addEventListener("submit", submitHandlerBlock);
}

if (document.getElementById('block-form')) {
    initFormBlock();
}

// newsletter

$( document ).on('change', '.js-newsletterCustomerType', function() {
    if ($(this).val() == 'BUSINESS') {
        $('.js-newsletterCompany').removeClass('d-none');
    } else {
        $('.js-newsletterCompany').addClass('d-none');
    }
});


function loadRecaptchaNewsletter(form) {
    grecaptcha.execute(recaptchaKey, { action: 'recaptcha' }).then(function (token) {
        var recaptchaResponse = document.getElementById('newsletter_recaptcha');
        recaptchaResponse.value = token;

        $.ajax({
            url: url__newsletter_subscription+'?locale='+locale,
            data: new FormData(document.getElementById('newsletter-form')),// the formData function is available in almost all new browsers.
            type: "post",
            contentType: false,
            processData: false,
            cache: false,
            dataType: "json", // Change this according to your response from the server.
            error: function(err) {
                alert('Ops! SI è verificato un errore. Riprova più tardi.');
            },
            success: function(data) {
                $('form#newsletter-form').replaceWith(data.html);
                setTimeout(function () {
                    initFormNewsletter();
                }, 500);
                if (data.result) {
                    MicroModal.close('modalNewsletter');
                    MicroModal.show('newsletter-form-modal');
                    window.dataLayer =  window.dataLayer || [];
                    dataLayer.push({
                        'event': 'submit',
                        'form_submitted': 'newsletter'
                    });
                    // fbq_trackCustom('submit__newsletter');
                }
            },
            complete: function(){
                // console.log("Request finished.");
            }
        });
    });
}

var submitHandlerNewsletter = function(e) {
    e.preventDefault();
    e.target.removeEventListener('submit', submitHandlerNewsletter, false);

    document.getElementById('newsletter-form-submit').classList.add('d-none');
    document.getElementById('newsletter-form-loader').classList.remove('d-none');

    var form = $(this);
    loadRecaptchaNewsletter(form);
};

function initFormNewsletter() {
    document.getElementById('newsletter-form').addEventListener("submit", submitHandlerNewsletter);
}

if (document.getElementById('newsletter-form')) {
    initFormNewsletter();
}